module.exports = __webpack_public_path__ + "fonts/sourcesansproextralight.eedb6859.woff2";